var y = Object.defineProperty;
var g = (t, e, i) => e in t ? y(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var n = (t, e, i) => g(t, typeof e != "symbol" ? e + "" : e, i);
function l(t) {
  const e = {};
  return t.id && (e.id = t.id), t.url && (e.url = t.url), t.width && (e.width = t.width), t.height && (e.height = t.height), e;
}
function C(t) {
  const e = {};
  return t.id && (e.id = t.id), t.fields && (e.fields = t.fields), e;
}
function f(t) {
  const e = {};
  return t.id && (e.id = t.id), t.key && (e.key = t.key), t.namespace && (e.namespace = t.namespace), t.value && (e.value = t.value), t.reference && (e.reference = C(t.reference)), e;
}
function p(t) {
  const e = {};
  return t.name && (e.name = t.name), t.value && (e.value = t.value), e;
}
function h(t) {
  var i;
  const e = {};
  return t.id && (e.id = t.id), t.title && (e.title = t.title), t.price && (e.price = t.price), t.compareAtPrice && (e.compareAtPrice = t.compareAtPrice), (i = t.product) != null && i.id && (e.productId = t.product.id), t.image && (e.image = l(t.image)), t.metafields && (e.metafields = t.metafields.map(f)), t.selectedOptions && (e.selectedOptions = t.selectedOptions.map(p)), e;
}
function k(t) {
  const e = {};
  return t.id && (e.id = t.id), t.title && (e.title = t.title), t.description && (e.description = t.description), e;
}
function I(t) {
  const e = {};
  return t.id && (e.id = t.id), t.name && (e.name = t.name), t.values && (e.values = t.values), e;
}
function d(t) {
  const e = {};
  return t.id && (e.id = t.id), t.description && (e.description = t.description), t.descriptionHtml && (e.descriptionHtml = t.descriptionHtml), t.handle && (e.handle = t.handle), t.title && (e.title = t.title), t.priceRange && (e.priceRange = t.priceRange), t.compareAtPriceRange && (e.compareAtPriceRange = t.compareAtPriceRange), t.options && (e.options = t.options.map(I)), t.images && (e.images = t.images.nodes.map(l)), t.featuredImage && (e.featuredImage = t.featuredImage), t.metafields && (e.metafields = t.metafields.map(f)), t.variants && (e.variants = t.variants.nodes.map(h)), t.collections && (e.collections = t.collections.nodes.map(k)), t.tags && (e.tags = t.tags), e;
}
function v(t) {
  const e = {};
  return t.id && (e.id = t.id), t.price && (e.price = t.price), t.product && (e.product = d(t.product)), t.image && (e.image = l(t.image)), t.selectedOptions && (e.selectedOptions = t.selectedOptions.map(p)), e;
}
function $(t) {
  const e = {};
  return t.id && (e.id = t.id), t.attributes && (e.attributes = t.attributes), t.quantity !== void 0 && (e.quantity = t.quantity), t.merchandise && (e.merchandise = v(t.merchandise)), e;
}
function u(t) {
  const e = {};
  return t.id && (e.id = t.id), t.description && (e.description = t.description), t.title && (e.title = t.title), t.image && (e.image = l(t.image)), t.metafields && (e.metafields = t.metafields.map(f)), t.products && (e.products = t.products.nodes.map(d)), e;
}
function o(t) {
  var i, a;
  const e = {};
  return t.id && (e.id = t.id), t.checkoutUrl && (e.checkoutUrl = t.checkoutUrl), ((i = t.cost) == null ? void 0 : i.subtotalAmount) !== void 0 && (e.subtotal = (a = t.cost) == null ? void 0 : a.subtotalAmount), t.totalQuantity !== void 0 && (e.totalQuantity = t.totalQuantity), t.lines && (e.lines = t.lines.nodes.map($)), e;
}
class w {
  constructor(e, i) {
    n(this, "locale");
    n(this, "makeRequest");
    n(this, "checkoutUrl");
    n(this, "lines", []);
    n(this, "currency", "USD");
    n(this, "subtotal");
    n(this, "totalQuantity", 0);
    // all cart queries and mutation should get back the same properties
    n(this, "sharedGetCartProperties", `
        checkoutUrl
        id
        totalQuantity
        cost {
            subtotalAmount {
                amount
                currencyCode
            }
        }
        lines(first: 100) {
            nodes {
                id
                quantity
                merchandise {
                    ... on ProductVariant {
                        id
                        price {
                            amount
                            currencyCode
                        }
                        selectedOptions {
                            name
                            value
                        }
                        product {
                            id
                            title
                            tags
                            collections(first: 100) {
                                nodes {
                                    id
                                    title
                                }
                            }
                        }
                        image {
                            url
                        }
                    }
                }
                attributes {
                    key
                    value
                }
            }
        }`);
    this.locale = i, this.makeRequest = e;
  }
  get localeDirective() {
    return `@inContext(language: ${this.locale})`;
  }
  getCartId() {
    const e = localStorage.getItem("cartId");
    return e || (this.resetCart(), null);
  }
  resetCart() {
    delete this.checkoutUrl, this.lines = [], delete this.subtotal, this.totalQuantity = 0, localStorage.removeItem("cartId");
  }
  setCartValues(e) {
    var i, a;
    e.checkoutUrl && (this.checkoutUrl = e.checkoutUrl), e.lines && (this.lines = e.lines), e.subtotal && (this.subtotal = e.subtotal), ((i = e.subtotal) == null ? void 0 : i.currencyCode) !== "XXX" && (this.currency = ((a = e.subtotal) == null ? void 0 : a.currencyCode) ?? "USD"), e.totalQuantity && (this.totalQuantity = e.totalQuantity);
  }
  async createCart() {
    const e = `mutation {
            cartCreate(input: {}) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, i = await this.makeRequest(e), a = o(i.data.cartCreate.cart);
    return localStorage.setItem("cartId", a.id), this.setCartValues(a), a;
  }
  async refresh() {
    const e = this.getCartId();
    if (!e)
      return null;
    const i = `query getCart($cartId: ID!) @inContext(language: EN) {
            cart(id: $cartId) {
                ${this.sharedGetCartProperties}
            }
        }`, a = await this.makeRequest(i, {
      cartId: e
    });
    if (!a.data.cart)
      return this.resetCart(), null;
    const r = o(a.data.cart);
    return this.setCartValues(r), r;
  }
  async addItems(e) {
    let i = this.getCartId();
    i || (await this.createCart(), i = this.getCartId());
    const a = `mutation add($cartId: ID!, $lines: [CartLineInput!]!) {
            cartLinesAdd(cartId: $cartId, lines: $lines) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lines: e
    }), c = o(r.data.cartLinesAdd.cart);
    return this.setCartValues(c), c;
  }
  async removeItem(e) {
    const i = this.getCartId();
    if (!i)
      throw new Error("No cart is available");
    const a = `mutation remove($cartId: ID!, $lineIds: [ID!]!) {
            cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lineIds: e
    }), c = o(r.data.cartLinesRemove.cart);
    return this.setCartValues(c), c;
  }
  async updateItems(e) {
    const i = this.getCartId();
    if (!i)
      throw new Error("No cart is available");
    const a = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
            cartLinesUpdate(cartId: $cartId, lines: $lines) {
                cart {
                    ${this.sharedGetCartProperties}
                }
            }
        }`, r = await this.makeRequest(a, {
      cartId: i,
      lines: e
    }), c = o(r.data.cartLinesUpdate.cart);
    return this.setCartValues(c), c;
  }
  async setCountryCode(e) {
    const i = this.getCartId();
    if (!i)
      throw new Error("No cart is available");
    const a = `mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
            cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId)  {
                cart {
                  ${this.sharedGetCartProperties}
                }
                userErrors {
                      field
                      message
                    }
                }
            }`, r = {
      countryCode: e
    }, c = await this.makeRequest(a, {
      cartId: i,
      buyerIdentity: r
    }), s = o(c.data.cartBuyerIdentityUpdate.cart);
    return this.setCartValues(s), s;
  }
}
class P {
  constructor(e, i = "EN", a = "US") {
    n(this, "locale");
    n(this, "countryCode");
    n(this, "makeRequest");
    this.locale = i, this.countryCode = a, this.makeRequest = e;
  }
  get localeDirective() {
    return `@inContext(language: ${this.locale}, country: ${this.countryCode})`;
  }
  // TODO: Investigate generic 'getObject' method that takes a full gid://
  // string, identifies the type of the result, and returns it along with a
  // selection of common fields. Useful if you have a Product or a Variant and
  // don't necessarily know which it is in advance.
  /**
   * Get storefront pricing information for a product id. Useful for fetching
   * packs, bundles and standalone titles.
   *
   * Used in jbg-web
   */
  async getStorefrontPricing(e) {
    const i = `query getProductBy($id: ID!) ${this.localeDirective} {
            product(id: $id) {
                title
                variants(first: 1) {
                    nodes {
                        id
                        title
                        price {
                            amount
                        }
                    }
                }
                metafields(
                    identifiers: [{ namespace: "custom", key: "storefront_pricing" }]
                ) {
                    key
                        reference {
                        ... on Metaobject {
                            fields {
                                key
                                value
                            }
                        }
                    }
                }
                priceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                }
                compareAtPriceRange {
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
            }
        }`, a = await this.makeRequest(i, {
      id: `gid://shopify/Product/${e}`
    });
    return d(a.data.product);
  }
  /**
   * Gets a list of Products in a Collection
   *
   * Used on jackboxgames.com to show products for sale
   */
  async getCollectionProducts(e) {
    const i = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/${e}") {
                products(first: 100) {
                    nodes {
                        handle
                        title
                        options {
                            id
                            name
                            values
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        compareAtPriceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        featuredImage {
                            url
                            width
                            height
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                image {
                                    url
                                    height
                                    width
                                }
                                selectedOptions {
                                    name
                                    value
                                }
                                price {
                                    amount
                                    currencyCode
                                }
                                compareAtPrice {
                                    amount
                                    currencyCode
                                }
                            }
                        }
                    }
                }
            }
        }`, a = await this.makeRequest(i);
    return u(a.data.collection);
  }
  /**
   * Gets details for a specific product
   *
   * Used on jackboxgames.com to show products for sale
   */
  async getProduct(e, i) {
    let a = "";
    i && (a = `metafields(identifiers: [
                ${i.map((m) => `{ namespace: "${m.namespace}", key: "${m.key}"}`).join(",")}
            ]) {
                    key
                        reference {
                        ... on Metaobject {
                            fields {
                                key
                                value
                            }
                        }
                    }
                }
            `);
    const r = `query ${this.localeDirective} {
            product(handle: "${e}") {
                id
                handle
                title
                descriptionHtml
                description
                images(first: 20) {
                    nodes {
                        id
                        url
                        width
                        height
                        altText
                    }
                }
                options {
                    id
                    name
                    values
                }
                ${a}
                priceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
                compareAtPriceRange {
                    minVariantPrice {
                        amount
                        currencyCode
                    }
                    maxVariantPrice {
                        amount
                        currencyCode
                    }
                }
                featuredImage {
                    url
                    width
                    height
                }                    
                variants(first: 100) {
                    nodes {
                        id
                        title
                        selectedOptions {
                            name
                            value
                        }
                        image {
                            url
                            height
                            width
                        }
                        price {
                            amount
                            currencyCode
                        }
                        compareAtPrice {
                            amount
                            currencyCode
                        }
                    }
                }
            }
        }`, c = await this.makeRequest(r);
    return d(c.data.product);
  }
  /**
   * Gets a the collection of products used in TKO 2 shopping ui
   *
   * Used in TKO2 galleries
   */
  async getTeeKO2Products() {
    const e = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/269996851334") {
                products(first: 100) {
                    nodes {
                        handle
                        metafields(identifiers: [
                            { namespace: "custom", key: "teeko2_metadata" },
                            { namespace: "custom", key: "product_type" }
                        ]) {
                            key
                            value
                            reference {
                                ... on Metaobject {
                                    fields {
                                        key
                                        value
                                    }
                                }
                            }
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                price {
                                    amount
                                    currencyCode
                                }
                                metafields(
                                    identifiers: [
                                        { namespace: "gooten", key: "layout_image" }
                                    ]
                                ) {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, i = await this.makeRequest(e);
    return u(i.data.collection);
  }
  /**
   * Gets a the collection of products used in TKO shopping ui
   *
   * Used in new TKO galleries
   */
  async getTeeKO1Products() {
    const e = `query ${this.localeDirective} {
            collection(id: "gid://shopify/Collection/279592632454") {
                products(first: 100) {
                    nodes {
                        handle
                        metafields(identifiers: [
                            { namespace: "custom", key: "teeko2_metadata" },
                            { namespace: "custom", key: "product_type" }
                        ]) {
                            key
                            value
                            reference {
                                ... on Metaobject {
                                    fields {
                                        key
                                        value
                                    }
                                }
                            }
                        }
                        variants(first: 100) {
                            nodes {
                                id
                                title
                                price {
                                    amount
                                    currencyCode
                                }
                                metafields(
                                    identifiers: [
                                        { namespace: "gooten", key: "layout_image" }
                                    ]
                                ) {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, i = await this.makeRequest(e);
    return u(i.data.collection);
  }
  /**
   * Gets a product and populates any metafields.
   *
   * Used in TKO2 `merch` renderer
   */
  async getProductWithMetafields(e, i) {
    const a = `query productWithMetafields($id: ID!, $metafields: [HasMetafieldsIdentifier!]!) ${this.localeDirective} {
            node(id: $id) {
                ... on Product {
                    metafields(identifiers: $metafields) {
                        key
                        value
                        reference {
                        ... on Metaobject {
                                fields {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, r = await this.makeRequest(a, {
      id: `gid://shopify/Product/${e}`,
      metafields: i
    });
    return d(r.data.node);
  }
  /**
   * Gets a product variant and populates any metafields.
   *
   * Used in TKO2 `merch` renderer
   */
  async getVariantWithMetafields(e, i) {
    const a = `query variantWithMetafields($id: ID!, $metafields: [HasMetafieldsIdentifier!]!) ${this.localeDirective} {
            node(id: $id) {
                ... on ProductVariant {
                    product {
                        id
                    }
                    metafields(identifiers: $metafields) {
                        key
                        value
                        reference {
                        ... on Metaobject {
                                fields {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }`, r = await this.makeRequest(a, {
      id: `gid://shopify/ProductVariant/${e}`,
      metafields: i
    });
    return h(r.data.node);
  }
}
class R {
  constructor(e) {
    n(this, "shopUrl");
    n(this, "apiToken");
    n(this, "isDebug");
    n(this, "locale");
    n(this, "countryCode");
    n(this, "query");
    n(this, "cart");
    this.shopUrl = `https://${e.shopName}.myshopify.com/api/2023-10/graphql.json`, this.apiToken = e.apiToken, this.locale = this.parseLocale(e.locale), this.countryCode = e.countryCode || "US", this.isDebug = e.debug ?? !1, this.query = new P(this.makeRequest.bind(this), this.locale, this.countryCode), e.enableCart && (this.cart = new w(this.makeRequest.bind(this), this.locale));
  }
  setLocale(e) {
    this.locale = this.parseLocale(e);
  }
  /**
   * Shopify expects ISO 639-1 language codes so this converts
   * controller language codes to valid ISO codes either from a
   * map or by simply uppercasing them.
   */
  parseLocale(e) {
    return e ? {
      "es-XL": "ES",
      "pt-BR": "PT_BR",
      "pt-br": "PT_BR"
    }[e] || e.toLocaleUpperCase() : "EN";
  }
  // Request
  async makeRequest(e, i = {}) {
    const a = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Shopify-Storefront-Access-Token": this.apiToken
      }),
      body: JSON.stringify({ query: e, variables: i })
    }, r = await fetch(this.shopUrl, a);
    if (!r.ok)
      throw console.error(r), new Error("Shopify response is not okay");
    let c;
    try {
      c = await r.json();
    } catch (s) {
      throw new Error("Failed to parse Shopify response as JSON", { cause: s });
    }
    if (this.isDebug && console.log(c), c.errors)
      throw console.error(c.errors), new Error("Errors returned in Shopify response");
    return c;
  }
  // Static helpers
  static getMetaValue(e, i) {
    const a = i.split(".");
    if (a.length > 2) {
      console.warn("getMetaValue only supports 1 level of reference fields");
      return;
    }
    const r = e.find((s) => s.key === a[0]);
    if (!r) {
      console.warn(`getMetaValue could find a field with key ${a[0]}`);
      return;
    }
    if (a.length === 1) {
      if (!r.value) {
        console.warn(`getMetaValue could find a value for key ${a[0]}`);
        return;
      }
      return r.value;
    }
    if (!r.reference) {
      console.warn(`getMetaValue could find reference for key ${a[0]}`);
      return;
    }
    if (!r.reference.fields) {
      console.warn(`getMetaValue could find a fields for key ${a[0]}`);
      return;
    }
    const c = r.reference.fields.find((s) => s.key === a[1]);
    if (!c) {
      console.warn(`getMetaValue could find a field for key ${a[1]}`);
      return;
    }
    if (!c.value) {
      console.warn(`getMetaValue could find a value for key ${a[1]}`);
      return;
    }
    return c.value;
  }
}
export {
  R as default
};
